import * as React from 'react';
import { Overlay } from '../components/Overlay';
import { ThumbsGrid } from '../components/ThumbsGrid';
import Layer from '../data/Layer';
import { storeDispatch } from '../state/Store';
import { createCanvasWithGradient } from '../utils/GraphicsUtils';
import { trackEvent } from 'utils/Tracker';
import { AddGradientFrameCommand } from 'state/commands/AddGradientFrameCommand';

interface Gradient {
  start: string;
  end: string;
}

const GRADIENTS: Gradient[] = [
  {
    start: '#F040EB',
    end: '#FC595A'
  },
  {
    start: '#1BBECF',
    end: '#99CDE3'
  },
  {
    start: '#A5A92E',
    end: '#A9D57E'
  },
  {
    start: '#E6B034',
    end: '#F6D562'
  },
  {
    start: '#2FB1BF',
    end: '#68D4A2'
  },
  {
    start: '#DF51E5',
    end: '#A858D5'
  },
  {
    start: '#56E5AF',
    end: '#BDCF07'
  },
  {
    start: '#E34BEC',
    end: '#30C2FE'
  },
  {
    start: '#FB4F4D',
    end: '#FFA02F'
  },
  {
    start: '#5D3DDE',
    end: '#C695E7'
  },
  {
    start: '#F69C22',
    end: '#ABD883'
  },
  {
    start: '#FED018',
    end: '#FD5854'
  }
];

interface Props {
  layer?: Layer;
}

const createImageUrlFromGradient = (gradient: Gradient): string => {
  const canvas = createCanvasWithGradient(270, 480, [
    gradient.start,
    gradient.end
  ]);
  return canvas.toDataURL('image/png');
};

export const GradientSelector: React.FunctionComponent<Props> = props => {
  const didSelectGradient = async (gradient: Gradient) => {
    const { start, end } = gradient;
    trackEvent('Add Gradient', { start, end });
    storeDispatch(new AddGradientFrameCommand(props.layer?.id, start, end));
  };

  return (
    <Overlay>
      <span className="gradient-selector">
        <ThumbsGrid title="Choose gradient">
          {GRADIENTS.map((g, index) => (
            <div key={index} onClick={() => didSelectGradient(g)}>
              <div className="thumbs-grid-thumb thumbs-grid-thumb--gradient">
                <img src={createImageUrlFromGradient(g)} />
              </div>
            </div>
          ))}
        </ThumbsGrid>
      </span>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/modals/GradientSelector.tsx